import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export type ProductDimension = { name: string, value: string }

export enum ProductStatus {
    'Active' = 'Active',
    'Deprecated' = 'Deprecated',
    'Draft' = 'Draft'
}


export type Product = {
    id: string,
    name: string,
    status: ProductStatus,
    description?: string,
    current: boolean,
    baseFee: string,
    included: string,
    price: string,
    features: {
        title: string,
        supported: boolean
    }[],
    freeTrial: boolean
    productIds: string[],
    createdByUsername?: string,
    createdBy?: { username: string, givenName: string, familyName: string },
    created?: string,
    updated?: string,

    // experimental
    trialLength?: number,
    setupFee?: number,
    billingPeriod?: number,
    subscriptionTermLength?: number
    totalBillingCycles?: number
    autoRenew?: boolean,
    pricingModel?: string,
}


export interface IProductTableColumn extends ITableColumn {
    render?: (item: Product) => ReactNode;
}

export type ListProducts = {
    listProducts: { items: Product[] }
}

export type GetProduct = {
    getProduct: Product
}

export type CreateProduct = {
    createProduct: Product
}

export type UpdateProduct = {
    updateProduct: Product
}

export type DeleteProduct = {
    deleteProduct: string
}
